import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, GraduationCap, Award, Wrench, Star } from "lucide-react";
import { api } from "@/lib/api";

export default function DoctorProfile() {
  const { id } = useParams();
  const [d, setD] = useState(null);

  useEffect(() => { api.get(`/doctors/${id}`).then((r) => setD(r.data)).catch(() => setD(false)); }, [id]);
  if (d === false) return <div className="container-x py-16 text-center">Doctor not found.</div>;
  if (!d) return <div className="container-x py-16 text-center text-slate-500">Loading…</div>;

  return (
    <div className="container-x py-10" data-testid={`doctor-profile-${d.id}`}>
      <Link to="/doctors" className="text-sm text-brand-purple inline-flex items-center gap-1 mb-6" data-testid="back-to-doctors"><ArrowLeft className="h-4 w-4" /> Back to all doctors</Link>
      <div className="grid md:grid-cols-3 gap-8">
        <div className="md:col-span-1">
          <img src={d.photo} alt={d.name} className="w-full rounded-2xl object-cover aspect-square" />
          <div className="mt-4 flex flex-col gap-2">
            <Link to={`/book-appointment?doctor=${d.id}`} className="btn-primary justify-center" data-testid="profile-book-btn">Book Appointment</Link>
            <Link to={`/second-opinion?doctor=${d.id}`} className="btn-secondary justify-center" data-testid="profile-opinion-btn">Get Second Opinion</Link>
          </div>
        </div>
        <div className="md:col-span-2 space-y-6">
          <div>
            <h1 className="text-3xl md:text-4xl font-bold">{d.name}</h1>
            <div className="text-brand-purple font-semibold mt-1">{d.specialty}</div>
            <div className="text-sm text-slate-500 mt-1">{d.qualification}</div>
            <div className="text-sm text-slate-600 mt-3">{d.experience_years}+ years of experience • Speaks {d.languages.join(", ")} • Timings: {d.timings}</div>
            <p className="text-slate-700 mt-4 leading-relaxed">{d.profile}</p>
          </div>

          {[
            { title: "Education", icon: GraduationCap, items: d.education },
            { title: "Expertise", icon: Wrench, items: d.expertise },
            { title: "Procedures Performed", icon: Star, items: d.procedures },
            { title: "Awards & Achievements", icon: Award, items: d.awards },
          ].map((sec) => (
            <div key={sec.title} className="card-clean p-6" data-testid={`section-${sec.title.toLowerCase().split(" ")[0]}`}>
              <div className="flex items-center gap-2 mb-3 text-brand-purple"><sec.icon className="h-5 w-5" /><h3 className="font-semibold text-lg">{sec.title}</h3></div>
              <ul className="list-disc pl-5 text-slate-700 space-y-1">{sec.items?.map((x, i) => <li key={i}>{x}</li>)}</ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
